// Copyright (c) 2016 Deere & Company

import './pip-history-item-header.scss';
import React, {PropTypes} from 'react';
import IncentivePrograms from '@deere/cps-it.warranty-model-factory/lib/incentive-programs';

const IncentiveProgramsItemHeader = props =>
    <header className='pip-history-item-header'>
        <a
            href={props.incentiveProgram.incentiveURL}
            rel='noopener noreferrer'
            target='_blank'
        >
            {props.incentiveProgram.label}
        </a>
    </header>;

IncentiveProgramsItemHeader.displayName = 'IncentiveProgramsItemHeader';
IncentiveProgramsItemHeader.propTypes = {
    incentiveProgram: PropTypes.instanceOf(IncentivePrograms).isRequired,
    pin: PropTypes.string.isRequired

};

export default IncentiveProgramsItemHeader;




// WEBPACK FOOTER //
// ./src/product/details/components/incentive-programs-item-header.js